import { create } from 'zustand';

interface SurveyModalState {
  /** 属性収集モーダルが画面に出ているか (質問表示中 + 回答後のポイント獲得演出中も含む)。
   *  ナビゲーションガイドはこれが false になってから起動する
   *  (回答直後はプロファイル更新でアンケート未回答は解消するが、獲得演出で
   *   モーダルが数秒残るため、閉じ切るまでガイドを待つ)。 */
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const useSurveyModalStore = create<SurveyModalState>((set) => ({
  visible: false,
  setVisible: (visible) => set((state) => (state.visible === visible ? state : { visible })),
}));
